import { FC, memo } from "react";
import { IScrollCustomProps } from "./scrollCustom.props";
import { Container } from "./scrollCustom.style";

const ScrollCustom: FC<IScrollCustomProps> = (props: IScrollCustomProps) => {
  return <Container {...props}></Container>;
};

export default memo(ScrollCustom);
